import script from "./SubscriptionDetailPaymentHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionDetailPaymentHistoryCard.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionDetailPaymentHistoryCard.vue?vue&type=style&index=0&id=480591b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480591b9"]])

export default __exports__